import React from 'react';

import AppErrorModal from '~/components/AppErrorModal';
import DeclineModal from '~/components/DeclineModal';
import IdleUserTimer from '~/components/IdleUserTimer';
import SoftDeclineModal from '~/components/SoftDeclineModal';
import { useAppContent, useDecline } from '~/hooks';
import { IdleSession } from '~/types/enums';

const ModalsAndFloating = () => {
  const { status } = useAppContent();
  const { errors, softErrors, hardErrors } = useDecline();

  return (
    status === 'ready' && (
      <>
        {hardErrors?.length > 0 && <DeclineModal errors={hardErrors} />}
        {softErrors?.length > 0 && <SoftDeclineModal errors={softErrors} />}
        {errors?.length > 0 && <AppErrorModal errors={errors} />}

        <IdleUserTimer
          timeoutMinutes={IdleSession.Timeout}
          countdownMinutes={IdleSession.Countdown}
        />
      </>
    )
  );
};

export default ModalsAndFloating;
